import JQueryView, { on } from '@/common/views/jqueryView';

// 状態クラス
const activeClass = 'is-active';
const showClass = 'is-show';

// タブパネル
const TAB_SELECTOR = '.js-tab';
const PANEL_SELECTOR = '.js-panel';
const TAB_NAV_SELECTOR = '.js-tab-nav';

// FAQ
const FAQ_TOGGLE_SELECTOR = '.js-faq-toggle';

export default class AboutPageView extends JQueryView {
  constructor() {
    super('#sb-site');
  }

  @on({ event: 'click', selector: TAB_SELECTOR })
  onTabClick(e: JQuery.ClickEvent) {
    const index = $(TAB_SELECTOR).index(e.currentTarget);
    this.activateTab(index);
  }

  @on({ event: 'click', selector: TAB_NAV_SELECTOR })
  onNavigationClick(e: JQuery.ClickEvent) {
    const index = Number($(e.currentTarget).data('index'));
    this.activateTab(index);
  }

  private activateTab(index: number): void {
    $(TAB_SELECTOR).removeClass(activeClass).eq(index).addClass(activeClass);
    $(PANEL_SELECTOR).removeClass(showClass).eq(index).addClass(showClass);
  }

  @on({ event: 'click', selector: FAQ_TOGGLE_SELECTOR })
  onFaqToggle(e: JQuery.ClickEvent) {
    $(e.currentTarget).toggleClass(activeClass).next().slideToggle();
  }
}
